import { Header } from './components/Header'
import { SummaryStats } from './components/SummaryStats'
import { ScanResults } from './components/ScanResults'
import { OptionChain } from './components/OptionChain'
import { useScan } from './hooks/useScan'
import { useChain } from './hooks/useChain'

function App() {
  const scan = useScan({ underlying: 'BTCUSDT', top: '20' })
  const chain = useChain({ underlying: 'BTCUSDT', max_dte: '60' })

  return (
    <div className="min-h-screen bg-ev-dark overflow-x-hidden">
      <Header />

      <main className="mx-auto max-w-[1600px] space-y-4 p-3 sm:space-y-5 sm:p-4 md:p-6">
        <SummaryStats scan={scan.data} chain={chain.data} />

        <div className="grid gap-4 sm:gap-5 lg:grid-cols-[1fr_1fr]">
          <ScanResults underlying="BTCUSDT" top={20} />
          <OptionChain underlying="BTCUSDT" maxDte={60} />
        </div>

        <footer className="border-t border-ev-border pt-4 text-center text-[11px] text-gray-600">
          OptiQuant-EV · FastAPI + React + Tailwind · Data via Binance
        </footer>
      </main>
    </div>
  )
}

export default App
